<template>
    <div style="display: flex; flex-direction: column; align-items: center">
        <div style="margin: 28px">
            <span style="font-size: 22px">申请流程</span>
        </div>
        <div class="jxzb-table" style="width: 100%">
            <!-- <el-table :data="tableData" :span-method="objectSpanMethod" border class="jxzb-tables"> -->
            <el-table ref="table" :data="tableData" border class="jxzb-tables" @cell-click="openwork">
                <el-table-column type="index" label="序号" width="50" align="center" />
                <el-table-column prop="flSubject" label="申请事由" align="left" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span style="color: #42a5f5">{{ scope.row.flSubject }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="flType" label="文件类型" width="150" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="flCreator" label="申请人" width="120" align="center" :show-overflow-tooltip="true" />
                <el-table-column prop="flCreateDate" label="申请日期" width="150" align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ $moment(scope.row.flCreateDate).format('YYYY年MM月DD日') }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="wfNodeNames" label="流程状态" width="150" :show-overflow-tooltip="true" align="center" />
            </el-table>
        </div>

    </div>
</template>
<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 },
        wfEngineUrl: { type: String, default: null }
    },
    data() {
        return {
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                params: { id: this.vo.id },
                url: 'tbgl/tbxmArch/getProcessById'
            }).then(
                (response) => {
                    if (response.code === 'success') {
                        this.tableData = response.body.listdata
                    } else {
                        this.$message.error(response.message)
                    }
                },
                (err) => {
                    console.log(err)
                }
            )
        },
        openwork(row) {
            console.log(row, 123123)
            // 通过 / 拆分
            let path = row.module.split('/')
            console.log(path)

            // window.open('#/wflow?wfEngineUrl=' + row.module + '&busiDataId=' + row.id + '&orgCode=' + this.$store.getters.loginUser.orgCode)
            window.open('#/wflow?wfEngineUrl=' + path[1] + '%2F' + path[2] + '&busiDataId=' + row.id + '&orgCode=' + this.$store.getters.loginUser.orgCode)
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';
</style>
